import * as React from 'react';
import { numericFont } from '../sharedStyle/font';

interface IProps {
  children: React.ReactNode;
  numeric?: boolean;
  size?: 'tiny' | 'small' | 'normal' | 'large';
  style?: React.CSSProperties;
}

export const Text = ({ children, numeric, size, style }: IProps) => {
  const textStyle = {
    fontFamily: numeric ? numericFont : 'inherit',
    fontSize:
      size === 'tiny'
        ? '0.846153846rem'
        : size === 'small' ? '0.923076923rem' : size === 'large' ? '1.076923077rem' : '1rem',
    ...style,
  };
  return <span style={textStyle}>{children}</span>;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/presentation/component/Text.tsx